import { useMemo } from 'react';

import { useGetListingQuery } from '../../../../RTK/api/reservations';

import useListingHandler from '../../controller/useListingHandler';

import { CardProps } from '../Card';

import ListSectionsRender from './Render';

const ListSectionsPopular = ({
  favoriteOnly = false,
  onBookNow,
}: {
  favoriteOnly?: boolean;
  onBookNow: CardProps['onBookNow'];
}) => {
  const { requestPayload, requestSkip } = useListingHandler();

  const payload = useMemo(
    () => ({
      ...requestPayload,
      favorite_only: favoriteOnly,
      limit: 10,
      offset: 0,
      ...(!favoriteOnly && { sort: [...requestPayload.sort, 'popular,desc'] }),
    }),
    [favoriteOnly, requestPayload],
  );

  const { data, isFetching } = useGetListingQuery(
    { payload },
    { skip: requestSkip },
  );

  return (
    <ListSectionsRender
      data={data?.result}
      isLoading={isFetching}
      title={favoriteOnly ? 'My Favorite' : 'Popular'}
      onBookNow={onBookNow}
    />
  );
};

export default ListSectionsPopular;
